import {
  buildAdminQueryRoot,
  buildScopedAdminQueryKey,
  type AdminQueryKey,
  type AdminQueryRoot,
  type OrganizationIdInput,
} from '@/lib/organization-scoping'
import type { AddOnSetIndexScope, AddOnSetScope, AddOnSetShowKeyEntries } from './addOnSets.api'

/** Without an organization, the root key matches every organization's add-on sets. */
interface OrganizationScope {
  organizationId?: OrganizationIdInput
}

/** The key entries each fetcher reads; the scoped key builders below set them. */
type AddOnSetIndexQueryKey = [AdminQueryRoot & AddOnSetIndexScope]
type AddOnSetShowQueryKey = [AdminQueryRoot & AddOnSetShowKeyEntries]

export const addOnSetQueryKeys = {
  all: ({ organizationId }: OrganizationScope = {}): AdminQueryKey => [
    buildAdminQueryRoot({ entity: 'productAddOnSet' }, { organizationId }),
  ],
  index: ({ organizationId, filters }: AddOnSetIndexScope): AddOnSetIndexQueryKey =>
    buildScopedAdminQueryKey(addOnSetQueryKeys.all({ organizationId })[0], {
      organizationId,
      scope: 'index',
      filters,
    }),
  show: ({ organizationId, addOnSetId }: AddOnSetScope): AddOnSetShowQueryKey =>
    buildScopedAdminQueryKey(addOnSetQueryKeys.all({ organizationId })[0], {
      organizationId,
      scope: 'show',
      addOnSetId,
    }),
}
